// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"7853ac8c","787":"f4da1551"}[chunkId] + ".chunk.js";
};